import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './MainSearchSnippetsContainer';
import { LegislationSnippet } from './legislation/LegislationSnippet';
import { SearchCommentarySnippet } from './commentary/SearchCommentarySnippet';
import styles from './main_search_snippets.module.scss';
import { LegislativeTextSnippet } from '../../../../components/legislative-text-snippet/LegislativeTextSnippet';

type Props = PropsFromRedux;

export const RawMainSearchSnippets: FC<Props> = ({
  legislationSnippet,
  commentariesSnippet,
  originalQueryKey,
}) => {
  const snippetType = legislationSnippet?.type ?? 'article';
  return (
    <div className={styles.wrapper}>
      {legislationSnippet && snippetType === 'article' && (
        <LegislationSnippet
          originalQueryKey={originalQueryKey}
          legislation={legislationSnippet}
        />
      )}
      {legislationSnippet && snippetType === 'text' && (
        <LegislativeTextSnippet
          href={legislationSnippet.url}
          title={legislationSnippet.title}
          articleCount={legislationSnippet.articleCount}
          source="law-snippet"
        />
      )}

      {!!commentariesSnippet && (
        <SearchCommentarySnippet commentaries={commentariesSnippet} />
      )}
    </div>
  );
};
export const MainSearchSnippets = Connect(RawMainSearchSnippets);
